import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

interface AppearingPlaceholderTextProps {
  icon: ReactNode;
  label: string;
  /** Whether the text is visible constantly (not only on hover which is a default behavior) */
  isStatic: boolean;
}

export const AppearingPlaceholderText: FC<AppearingPlaceholderTextProps> = ({
  icon,
  label,
  isStatic,
}) => {
  return (
    <div
      className={cx(
        "flex w-full items-center gap-2 overflow-hidden group-hover/cell:flex",
        isStatic ? "flex" : "hidden"
      )}
    >
      {icon}
      <span className="truncate text-[13px] leading-[140%] font-normal text-[#707577]">
        {label}
      </span>
    </div>
  );
};
